import { api } from './api';

export const moodsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getMoodsAdmin: builder.query({
      query: (params = {}) => ({
        url: '/admin/moods',
        params:
          params.scope != null && String(params.scope).trim() !== ''
            ? { scope: String(params.scope).trim() }
            : {},
      }),
      providesTags: ['Mood'],
    }),
    createMood: builder.mutation({
      query: (body) => ({
        url: '/admin/moods',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Mood'],
    }),
    updateMood: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/admin/moods/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Mood'],
    }),
  }),
});

export const {
  useGetMoodsAdminQuery,
  useCreateMoodMutation,
  useUpdateMoodMutation,
} = moodsApi;
